const Getters = {
  // 備考定型分
  getPaymentMethodListFromState: (state) => {
    return state.paymentMethodList
  },
  getMaxSortNumber: (state) => {
    return state.maxSortNumber
  }
}

export default Getters
